var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDesktop = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.122 3H2.979C2.328 3 1.8 3.528 1.8 4.179v9.428c0 .651.528 1.179 1.179 1.179h14.143c.65 0 1.178-.528 1.178-1.179V4.18C18.3 3.528 17.772 3 17.122 3Z",
  stroke: "currentColor",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m11.818 17.142-.295-2.357H8.577l-.295 2.357h3.536Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.175 17.142h-8.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.8 11.839v1.768a1.182 1.182 0 0 0 1.179 1.178h14.143a1.182 1.182 0 0 0 1.178-1.178v-1.768H1.8Zm8.25 2.357a.59.59 0 1 1 0-1.18.59.59 0 0 1 0 1.18Z",
  fill: "currentColor"
})));
export { SvgDesktop as ReactComponent };